import React, { Component, useEffect, useState } from "react";

// Mui
import { Box } from "@mui/material";

// Jds
import {
  BadgeV2,
  Container,
  DropdownMenuGroup,
  DropdownMenuItem,
  Image,
  Text,
  Tooltip,
} from "@jds/core";

// Local
import CardOverlay from "../Cards/CardOverlay";
import KebabButton from "../Buttons/KebabButton";
import JdsMenu from "../JdsMenu";
import decryptUrl from "../../../util/img-decryption";
//img
import premium from "../../../assets/png/premium.png";
export default function AlbumCard({
  data,
  onClick,
  setEditData = () => { },
  setEditModalClose = () => { },
  setDeleteModalClose = () => { },
  setDeleteThumbnailModalClose = () => {},
}) {
  return (
    <Box
      width={184}
      height={184}
      borderRadius={6}
      position="relative"
      onClick={onClick}
      sx={{ overflow: "hidden", cursor: "pointer" }}
    >
      <CardOverlay />
      {/* <Image aspectRatio="1:1" src={data?.thumbnailImage || ""} /> */}
      <Image aspectRatio="1:1" src={decryptUrl(data?.thumbnailImage) || ""} />
      <Box
        sx={{
          position: "absolute",
          // top: "16px",
          bottom: "16px",
          left: "16px",
          zIndex: 2,
          maxWidth: "calc(100% - 32px)",
          backgroundColor: "#000",
          padding: "1px 4px",
          borderRadius: "4px",
        }}
      >
        {/* <BadgeV2
          label={data?.name || "Folder Name"}
          size="small"
          kind="information"
          informationKind="label"
          color="neutral"
        /> */}
        {/* <Text
          text={data?.name || "Folder Name"}
          color="white"
          appearance="body_xs"
          maxLines={1}
        /> */}
        <Tooltip label={data?.name || "Folder Name"} position="bottom">
          <p
            style={{
              color: "white",
              fontSize: "var(--font-sizes-body-xs)",
              textWrap: "nowrap",
              textOverflow: "ellipsis",
              overflow: "hidden",
              maxWidth: "152px",
            }}
          >
            {data?.name || "Folder Name"}
          </p>
        </Tooltip>
      </Box>
      <Container
        direction="column"
        verticalAlign="end"
        style={{
          position: "absolute",
          bottom: "16px",
          left: "16px",
          zIndex: 2,
        }}
        gap={4}
      >
        {/* <Text text={data.date || "Date"} appearance="body-xs" color="white" /> */}
        {/* <Text text={data.time || "Time"} appearance="body-xs" color="white" /> */}
      </Container>
      {/* {data?.isPremium && (
        <Box
          sx={{ position: "absolute", top: "16px", left: "16px", zIndex: 2 }}
        >
          <img src={premium} alt="" style={{ width: "32px" }} />
        </Box>
      )} */}
      <Box sx={{ position: "absolute", top: "16px", right: "16px", zIndex: 2 }}>
        <JdsMenu
          trigger={{
            component: KebabButton,
          }}
        >
          <DropdownMenuGroup hideBottomDivider>
            <DropdownMenuItem
              prefix={"IcEditPen"}
              label="Edit"
              value="edit"
              onClick={() => {
                setEditModalClose(false);
                setEditData(data);
              }}
            />
            <DropdownMenuItem
              prefix={"IcTrash"}
              label="Delete"
              value="delete"
              onClick={() => {
                setDeleteModalClose(false);
                setEditData(data);
              }}
            />
            {data?.thumbnailImage ? (
              <DropdownMenuItem
                prefix={"IcPhotoRemove"}
                label="Remove Thumbnail"
                onClick={() => {
                  setDeleteThumbnailModalClose(false);
                  setEditData(data);
                }}
              />
            ) : (
              ""
            )}
            {/* <DropdownMenuItem prefix={"IcShare"} label="Share" value="share" /> */}
          </DropdownMenuGroup>
        </JdsMenu>
      </Box>
    </Box>
  );
}
